import { extractToolResults } from "./agentChat/parseAgentMessage";

export type McpPlaygroundMessageRole = "user" | "assistant" | "system";

export type McpPlaygroundMessage = {
  id: string;
  role: McpPlaygroundMessageRole;
  content: string | Array<{ type?: string; text?: string }> | undefined;
};

export function playgroundUiMessage(
  role: McpPlaygroundMessageRole,
  content: string,
  id: string = crypto.randomUUID()
): McpPlaygroundMessage {
  return {
    id,
    role,
    content
  };
}

/** Map playground messages to the Backoffice agent BFF `{ role, content }` contract. */
export function messagesToAgentChatRequest(
  messages: McpPlaygroundMessage[]
): Array<{ role: "user" | "assistant"; content: string }> {
  return messages
    .filter((message): message is McpPlaygroundMessage & { role: "user" | "assistant" } => {
      return message.role === "user" || message.role === "assistant";
    })
    .map((message) => ({
      role: message.role,
      content: extractToolResults(messageText(message.content)).text.trim()
    }))
    .filter((message) => message.content.length > 0);
}

export function messageText(content: McpPlaygroundMessage["content"]): string {
  if (typeof content === "string") {
    return content;
  }

  if (!Array.isArray(content)) {
    return "";
  }

  return content
    .map((part) => (typeof part?.text === "string" ? part.text : ""))
    .filter(Boolean)
    .join("\n");
}
